module.exports = __webpack_public_path__ + "img/sweden-liver-cancer-female.941df182.png";